import {Model} from 'vue-mc';
import http from "../httpMiddleware/http";

Model.prototype.$http = http;
export default class interpreterJobActivityModel extends Model {

    defaults() {
        return {}
    }

    routes() {
        return {
            fetch: 'interpreter/activity'
        }
    }
}
